import { post } from 'libs/client/api-service'

export const signOut = async () => post(`/sign_out`)
